/**
 * Custom Vortex icon — spiral arcs converging to center.
 * Same design used in DeckFeedPage, extracted as shared component.
 * Matches Lucide style: 24x24, stroke currentColor, round caps.
 */
export function VortexIcon({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      className={className}
    >
      <circle cx="12" cy="12" r="3" strokeWidth="2" fill="none" />
      <path d="M12 5C8.13 5 5 8.13 5 12" strokeWidth="2" strokeLinecap="round" />
      <path d="M19 12c0 3.87-3.13 7-7 7" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 2c5.52 0 10 4.48 10 10" strokeWidth="1.5" strokeLinecap="round" opacity="0.6" />
      <path d="M2 12c0-5.52 4.48-10 10-10" strokeWidth="1.5" strokeLinecap="round" opacity="0.6" />
    </svg>
  );
}
